module.exports = __webpack_public_path__ + "fonts/19c03f4.eot";